module.exports = __webpack_public_path__ + "static/media/art26.7cc8b2e8.jpg";